import {useFormik} from "formik";
import ModalTemplate from "../../components/ModalTemplate/ModalTemplate";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import * as yup from "yup";
import {userIcon} from "../../components/Icon/Icon";
import PictureDrop from "../../components/Input/PictureDrop";

const validationSchema = yup.object({
    id: yup.mixed().nullable(),
    name: yup.string().required("Name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    changePassword: yup.boolean(),

    password: yup.string().when(['id', 'changePassword'], {
        is: (id, changePassword) => !id || changePassword === true,
        then: (schema) => schema.required("Password is required"),
        otherwise: (schema) => schema.notRequired()
    }),

    confirmPassword: yup.string().when(['id', 'changePassword'], {
        is: (id, changePassword) => !id || changePassword === true,
        then: (schema) => schema
            .required("Confirm password is required")
            .oneOf([yup.ref('password')], "Passwords must match"),
        otherwise: (schema) => schema.notRequired()
    })
});

const UserModal = ({onClose, onSubmit, user}) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: user?.id || '',
            name: user?.name || '',
            surname: user?.surname || '',
            email: user?.email || '',
            role: user?.role || 'user',
            color: user?.color || '',
            changePassword: false,
            password: '',
            confirmPassword: '',
            image: user.image ?? null
        },
        validationSchema,
        onSubmit: onSubmit
    });


    const footerActions = (
        <>
            <Button type="submit" form="userModalForm" variant="primary">Save</Button>
            <Button type="button" onClick={onClose} variant="secondary">Cancel</Button>
        </>
    );

    return (
        <ModalTemplate
            onClose={onClose}
            title={user.id ? "Update user" : "Create user"}
            icon={userIcon}
            footerActions={footerActions}
        >
            <form
                id="userModalForm"
                onSubmit={formik.handleSubmit} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        formik.handleSubmit();
                    }
                }}
            >
                <Input
                    name="name"
                    label="Name"
                    formik={formik}
                />
                <Input
                    name="surname"
                    label="Surname"
                    required={false}
                    formik={formik}
                />
                <Input
                    name="color"
                    label="Color"
                    formik={formik}
                    type="color"
                />
                <Input
                    name="email"
                    label="Email"
                    formik={formik}
                />

                {!formik.values?.id ? (
                    <>
                        <Input
                            name="password"
                            type="password"
                            label="Password"
                            formik={formik}
                        />
                        <Input
                            name="confirmPassword"
                            type="password"
                            label="Confirm Password"
                            formik={formik}
                        />
                        <PictureDrop
                            name="image"
                            label="Profile Picture"
                            formik={formik}
                        />
                    </>
                ) : (
                    <>
                        <PictureDrop
                            name="image"
                            label="Profile Picture"
                            formik={formik}
                        />
                        <Input
                            type="checkbox"
                            name="changePassword"
                            label="Change Password"
                            formik={formik}
                        />
                        {formik.values.changePassword && (
                            <>
                                <Input
                                    name="password"
                                    type="password"
                                    label="Password"
                                    formik={formik}
                                />
                                <Input
                                    name="confirmPassword"
                                    type="password"
                                    label="Confirm Password"
                                    formik={formik}
                                />
                            </>
                        )}
                    </>
                )}

                {formik.values.role !== 'superadmin' && (
                    <Input
                        type="checkbox"
                        name="isAdmin"
                        label="Admin"
                        handleChange={(e) => formik.setFieldValue('role', e.target.checked ? "admin" : "user")}
                        checked={formik.values.role === 'admin'}
                    />
                )}
            </form>
        </ModalTemplate>
    );
};

export default UserModal;